import axios from "axios";

export const addUsherToEvent = async (usherCode, hostId, userId) => {
  // console.log("addGuestToEvent", { usherCode, hostId, userId });

  try {
    const { data } = await axios.patch("/events/add-usher", {
      usherCode,
      hostId,
      usherId: userId,
    });

    return {
      success: true,
      message: data.message,
      isAlreadyInvited: data.isAlreadyInvited,
      event: data.event,
      isEventDatePassed: data.isEventDatePassed,
      isWrongRoleCode: data.isWrongRoleCode,
    };
  } catch (error) {
    const msg = error.response?.data?.message || "Failed to add usher";
    // console.log("error msg:", msg);

    return {
      success: false,
      message: msg,
      isAlreadyInvited:
        error.response?.data?.isAlreadyInvited ||
        msg.toLowerCase().includes("already invited"),
      isEventDatePassed: error.response?.data?.isEventDatePassed,
      isWrongRoleCode: error.response?.data?.isWrongRoleCode,
    };
  }
};
